<bb-page-header [icon]="'heartbeat'" [title]="'REALTIME' | translate">
	<bb-realtime-viewers class="bb-header-extra"></bb-realtime-viewers>
</bb-page-header>

<div class="body-column viewers-column" [ngClass]="loading ? 'loading' : '' ">
	<realtime-audience-graph class="block"></realtime-audience-graph>
	<realtime-audience-ticker class="block"></realtime-audience-ticker>
	<realtime-audience-view-sessions class="block"></realtime-audience-view-sessions>
</div>
<div class="body-column map-column" [ngClass]="loading ? 'loading' : '' ">
	<div *ngIf="showSocketToggle" class="realtime-development">
		<label>
			<bb-check [(ngModel)]="useDevSocket" (onChanged)="updateSocket($event)" title="Use development socket"></bb-check>
			<span>Use development socket</span>
		</label>
	</div>

	<realtime-audience-map class="block"></realtime-audience-map>
	<realtime-audience-toplist class="block"></realtime-audience-toplist>
</div>
<div class="loader" *ngIf="loading">
	<bb-loading></bb-loading>
</div>
